import PenaltyMasterRepositoryImpl from './impl/PenaltyMasterRepositoryImpl'

export default {
  getInstance () {
    return new PenaltyMasterRepositoryImpl()
  }
}
